import React, { ReactElement, useState } from 'react';
import FluzLogo from '../../assets/images/fluz-icons/Logo.png';
import InfoIcon from '../../assets/images/misc-icons/info-question.png';
import PreviousPageArrow from '../../assets/images/misc-icons/previous-page-arrow.png';
import { useIntercom } from 'react-use-intercom';
import { isMobileOrTabletBrowser } from '../../utils/device';
import FadedComponent from '../../components/layouts/FadedComponent';
import StagingNotice from './StagingNotice';

interface CardHeaderProps {
  title?: string;
  isInitialPage?: boolean;
  isStaging?: boolean;
}

export default function CardHeader({ title, isInitialPage = false, isStaging = false }: CardHeaderProps): ReactElement {
  const [isIntercomShown, setIsIntercomShown] = useState(false);
  const { hide, show } = useIntercom();

  function handleHelpButtonClick() {
    if (isIntercomShown) {
      hide();
    } else {
      show();
    }
    setIsIntercomShown(!isIntercomShown);
  }

  if (isInitialPage) {
    return (
      <div className="row header-row">
        {isStaging ? (
          <StagingNotice />
        ) : (
          <img src={FluzLogo} className={`card-fluz-logo ${isMobileOrTabletBrowser() ? '' : 'invisible'}`} />
        )}

        <button className="btn btn-header-background" onClick={handleHelpButtonClick}>
          <img src={InfoIcon} className="btn-header-link" />
        </button>
      </div>
    );
  } else {
    return (
      <div className="col header-column">
        <div className="row header-row">
          <button
            type="submit"
            className="btn btn-header-background"
            onClick={() => {
              history.go(-1);
            }}
          >
            <img src={PreviousPageArrow} className="btn-header-link" />
          </button>
          <FadedComponent>
            <div className="card-title">{title}</div>
          </FadedComponent>
          <button className="btn btn-header-background" onClick={handleHelpButtonClick}>
            <img src={InfoIcon} className="btn-header-link" />
          </button>
        </div>
      </div>
    );
  }
}
